
import { Component, Vue, Prop } from 'vue-property-decorator';
import { User } from '@/modules/authentication/models/user';

@Component({
  components: {}
})
export default class AboutApplicant extends Vue {
  @Prop()
  protected applicant?: User;

  protected get firstName(): string | null {
    return this.applicant?.givenName || null;
  }

  protected get lastName(): string | null {
    return this.applicant?.familyName || null;
  }

  protected get email(): string | null {
    return this.applicant?.email || null;
  }
}
